import { render, staticRenderFns } from "./View.vue?vue&type=template&id=e6406ff4&scoped=true&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"
import style1 from "@/assets/less/manage-space/base.less?vue&type=style&index=1&id=e6406ff4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6406ff4",
  null
  
)

export default component.exports